export default __webpack_public_path__ + "static/media/origommies.7b025a26.jpeg";